import { gql } from '__generated__';

export default gql(`
  mutation ExportTeams($input: ExportTeamsInput!) {
    exportTeams(input: $input) {
      id
    }
  }
`);
